import { supabase } from '../lib/supabase'
import { obtenerConteosSociosPorCurso } from './socioCursosService'

const cursoColumns = 'id, organizacion_id, anio, nombre, nivel, seccion, activo, created_at, updated_at'
const editableFields = ['anio', 'nombre', 'nivel', 'seccion', 'activo']

function requireOrganization(organizacionId) {
  if (!organizacionId) throw new Error('No fue posible identificar la organización.')
}

function editablePayload(values) {
  return editableFields.reduce((payload, field) => {
    if (field === 'anio') payload[field] = Number(values[field])
    else if (field === 'activo') payload[field] = values[field] === true
    else payload[field] = values[field]?.trim() || null
    return payload
  }, {})
}

function serviceError(error) {
  if (error?.code === '23505') return new Error('Ya existe un curso con este nombre para el año seleccionado.')
  return new Error('No fue posible completar la operación. Intenta nuevamente.')
}

export async function obtenerCursos({ organizacionId, page = 1, pageSize = 20, estado = 'todos', anio = '', search = '' }) {
  requireOrganization(organizacionId)
  const from = (page - 1) * pageSize
  const to = from + pageSize - 1
  const term = search.trim().replace(/[%_(),]/g, '')

  let query = supabase
    .from('cp_cursos')
    .select(cursoColumns, { count: 'exact' })
    .eq('organizacion_id', organizacionId)

  if (estado !== 'todos') query = query.eq('activo', estado === 'activo')
  if (anio) query = query.eq('anio', Number(anio))
  if (term) query = query.or(`nombre.ilike.%${term}%,nivel.ilike.%${term}%,seccion.ilike.%${term}%`)

  const { data, count, error } = await query
    .order('anio', { ascending: false })
    .order('nombre', { ascending: true })
    .range(from, to)

  if (error) throw serviceError(error)
  const cursos = data ?? []
  const memberCounts = await obtenerConteosSociosPorCurso(organizacionId, cursos.map((curso) => curso.id))
  return {
    cursos: cursos.map((curso) => ({ ...curso, socios_count: memberCounts[curso.id] ?? 0 })),
    total: count ?? 0,
  }
}

export async function obtenerCursoPorId(organizacionId, cursoId) {
  requireOrganization(organizacionId)
  const { data, error } = await supabase
    .from('cp_cursos')
    .select(cursoColumns)
    .eq('organizacion_id', organizacionId)
    .eq('id', cursoId)
    .maybeSingle()

  if (error) throw serviceError(error)
  if (!data) throw new Error('Curso no encontrado.')
  return data
}

export async function crearCurso(organizacionId, values) {
  requireOrganization(organizacionId)
  const { data, error } = await supabase
    .from('cp_cursos')
    .insert({ ...editablePayload(values), organizacion_id: organizacionId })
    .select(cursoColumns)
    .single()

  if (error) throw serviceError(error)
  return data
}

export async function actualizarCurso(organizacionId, cursoId, values) {
  requireOrganization(organizacionId)
  const { data, error } = await supabase
    .from('cp_cursos')
    .update(editablePayload(values))
    .eq('organizacion_id', organizacionId)
    .eq('id', cursoId)
    .select(cursoColumns)
    .maybeSingle()

  if (error) throw serviceError(error)
  if (!data) throw new Error('Curso no encontrado.')
  return data
}

export async function cambiarEstadoCurso(organizacionId, cursoId, activo) {
  requireOrganization(organizacionId)
  const { data, error } = await supabase
    .from('cp_cursos')
    .update({ activo: activo === true })
    .eq('organizacion_id', organizacionId)
    .eq('id', cursoId)
    .select(cursoColumns)
    .maybeSingle()

  if (error) throw serviceError(error)
  if (!data) throw new Error('Curso no encontrado.')
  return data
}
